module.exports = __webpack_public_path__ + "images/img1.png";